import React, { useEffect, useState } from "react";
import Button from "../Button/Button3";
import "./ConfirmDialog.css";

function ConfirmDialog({
  isOpen,
  title = "CONFIRM ACTION",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  busy = false,
  hideCancel = false,
  cancelFirst = false,
  consentLabel = null,
  requireConsent = false,
}) {
  const [consentChecked, setConsentChecked] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setConsentChecked(false);
      return;
    }
    setConsentChecked(false);
  }, [consentLabel, isOpen, message, requireConsent, title]);

  if (!isOpen) return null;

  const confirmDisabled = busy || (requireConsent && !consentChecked);
  const cancelButton = !hideCancel ? (
    <Button
      variant="small"
      primaryText={cancelText}
      onClick={onCancel}
      disabled={busy}
    />
  ) : null;
  const confirmButton = (
    <Button
      variant="small"
      primaryText={busy ? "Sending..." : confirmText}
      onClick={onConfirm}
      disabled={confirmDisabled}
    />
  );

  return (
    <div className="confirm-dialog-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <div className="confirm-dialog-card">
        <p className="confirm-dialog-title">{title}</p>
        <p className="confirm-dialog-message">{message}</p>
        {consentLabel ? (
          <div className="confirm-dialog-consent">
            <div className="confirm-dialog-consent-label">
              <input
                type="checkbox"
                checked={consentChecked}
                onChange={(event) => setConsentChecked(event.target.checked)}
              />
              <div className="confirm-dialog-consent-copy">{consentLabel}</div>
            </div>
          </div>
        ) : null}

        <div className={`confirm-dialog-actions ${hideCancel ? "single" : ""}`}>
          {cancelFirst ? cancelButton : confirmButton}
          {cancelFirst ? confirmButton : cancelButton}
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
